<template lang="pug">
.qmodii-modal-content.qmodii-symbolookup
  .qmodii-symbolookup.cont
    VCard
      VCardTitle
        span.headline {{ $t("labels.symbol_lookup") }}
      VCardText
        VTabs(v-model="model")
          VTab Lookup
          VTab Indices
        VTabsItems(v-model="model", vertical)
          VTabItem
            .qmodii-symbolookup-top
              div.qmodii-flex.qmodii-f1
                VTextField(:label="$t('labels.symbol_or_name')" autofocus @input="doLookup" @keydown.enter="addSymbol(symbolToLookUp)" v-model="symbolToLookUp")
                  VBtn(color="primary" fab small slot="append-outer" @click="addSymbol(symbolToLookUp)" style="top: -12px" offset-y)
                    VIcon(dark) add
              .qmodii-searchby
                VSelect(:label="$t('labels.search_by')" :items="dropdown.list" v-model="dropdown.selected" @input="setSearchby()" attach dense)
            .qmodii-symbolookup-bottom(v-if="results")
              div.qmodii-tabs
                div.qmodii-tab-item(v-for="(symbol, i , d) in results", @click="activeTab = i", :class="activeTab == i ? 'blue--text' : ''"): span {{$t(i)}}
              .qmodii-tab-content
                table.qmodii-table
                  tr(v-for="symbol in results[activeTab]", @click="addSymbol(symbol.symbol)" @mouseover="setHover(symbol,true)" @mouseout="setHover(symbol,false)" :class="getHover(symbol) ? 'blue--text' : ''").qmodii-tr
                    td.qmodii-td.qmodii-name: span.qmodii-name {{symbol.name}}
                    td.qmodii-td.qmodii-symbol: span.qmodii-symbol {{symbol.symbol}}
                    td.qmodii-td.qmodii-exchange: span.qmodii-exchange {{symbol.exchange}}
            .qmodii-symbolookup-bottom(v-else)
              .qmodii-tab-content
                table.qmodii-table
                  tr.qmodii-tr
                    td.qmodii-td.no-symbol {{$t('msgs.to_get_started_type_in_the_input_above')}}
          VTabItem
            VList(two-line, dense)
              VListTile(v-for="item in customIndcies", :key="item.symbol")
                VListTileContent
                  VListTileTitle {{ item.symbol }}
                  VListTileSubTitle {{ item.label }}
                VListTileAction
                  VBtn(color="primary", small, @click="addSymbol(item.symbol)")
                    | {{ $t('labels.add') }}
      VCardActions
        VSpacer
        VBtn(color="blue darken-1" flat @click.native="closeModal()") {{ $t("buttons.close") }}

</template>

<script>
import "vuetify/src/stylus/settings/_colors.styl";
import axios from "axios";
import ToggleButton from "@LAYOUT/ToggleButton";
import {
    VTab,
  VTabs,
  VTabsItems,
  VTabItem,
  VSelect,
  VIcon,
  VTextField,
  VBtn,
  VSpacer,
  VCard,
  VCardTitle,
  VCardText,
  VCardActions
} from "vuetify/lib";

export default {
  name: "symbolLookup",
  components: {
    VSelect,
    VIcon,
    VTextField,
    ToggleButton,
    VBtn,
    VSpacer,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions,
      VTab,
  VTabs,
  VTabsItems,
  VTabItem,
  },
  props: ["enabled", "token", "mutex", "customIndcies"],
  data() {
    return {
      timeout: null,
      timeoutTime : 300,
      model: 0,
      title: "symbolLookup",
      symbolToLookUp: "",
      isEnabled: this.enabled,
      searchby: "symbol",
      results: null,
      activeTab: "",
      dropdown: {
        open: false,
        selected: "symbol",
        list: [
          { text: this.$t("labels.name"), value: "name" },
          { text: this.$t("labels.symbol"), value: "symbol" }
        ]
      }
    };
  },
  methods: {
    closeModal() {
        //this.$store.commit[`AdvancedChart_${this.mutex}/SET_MODAL_ISOPEN`]
        this.$emit("addSymbolLookup_close", true);
        console.log(this.$store);
        if (this.$store.state[`AdvancedChart_${this.mutex}`])
          this.$store.commit(`AdvancedChart_${this.mutex}/SET_MODAL_ISOPEN`, false);
      // this.$store.commit("AdvancedChart/SET_MODAL_ISOPEN", false);
    },
    groupby(xs, f) {
      return xs.reduce(
        (r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r),
        {}
      );
    },
    async doLookup() {
      if (!this.symbolToLookUp) {
        this.results = null
      }
      else {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(async () => {
          if (!this.symbolToLookUp) {
            this.results = null
          }
          else {
          let lookupJSON = `//${this.$store.state.ENV}.quotemedia.com/datatool/lookup.json?q=${this.symbolToLookUp}&token=${this.token}&searchType=${this.searchby}`;
          try {
            const response = await axios.get(lookupJSON);
            if (response.data.length) {
              response.data.forEach(element => {
                element.isHover = false;
              });
              this.activeTab = response.data[0].symbolType;
              let gr = this.groupby(response.data, c => c.symbolType);

              this.results = Object.keys(gr)
                .sort()
                .reduce(
                  (acc, key) => ({
                    ...acc,
                    [key]: gr[key]
                  }),
                  {}
                );
            }
            else {
              this.results = null
            }
          } catch (e) {
            throw e;
          }
          }
        }, this.timeoutTime)
      }
    },
    setSearchby(dd, search, index) {
      this.searchby = this.dropdown.selected;
      this.doLookup();
    },
    addSymbol(symbol) {
      if (symbol == "") return;

      this.$emit("addSymbolLookup", symbol);
      if (this.$store.state[`AdvancedChart_${this.mutex}`])
        this.$store.commit(`AdvancedChart_${this.mutex}/SET_MODAL_ISOPEN`, false);
    },
    setHover(symbol, value) {
      return (symbol.isHover = value);
    },
    getHover(symbol) {
      return symbol.isHover;
    }
  },
  computed: {
    getEnabled() {
      return this.isEnabled ? "On" : "Off";
    }
  },
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus">
.qmodii-symbolookup-top
  .qmodii-symbolookup-add
    padding 5px
    box-shadow 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2)
  padding-top 3px
  .qmodii-btn-wrap
    margin-left 5px
  display flex
  > div
    flex-wrap nowrap
.qmodii-searchby-text
  white-space nowrap
  @media only screen and (max-width: 425px)
    display none
.qmodii-searchby
  flex 0
  min-width 100px
.qmodii-marg-left
  margin-left auto
.qmodii-marg-left-5
  margin-left 8px
.qmodii-table
  font-size 14px
  width 100%
  border-collapse collapse
  text-align right
  .qmodii-tr
    border-bottom 1px solid #EAEEF1
    padding 5px 0
    color $primary
    &:hover
      cursor pointer
    td:first-child
      padding 2px 0
      text-align left
.qmodii-tabs
  margin 5px 0
  padding-top 5px
  display flex
  border-bottom 1px solid $qmod-light-grey
  .qmodii-tab-item
    position relative
    bottom -1px
    cursor pointer
    border-bottom 2px solid #C3CED3
    margin-right 5px
    padding 5px
    &.qmodii-tab-active
      border-color $qmod-blue
      // color #fff
.qmodii-symbolookup
  .qmodii-symbolookup-input
    max-width 120px
    min-width 120px
    margin-right 8px
    height 100%
    padding 0 5px
  .qmodii-tab-content
    max-height 300px
    height 300px
    overflow-y auto
    margin 5px 0
  .qmodii-name
    white-space nowrap
    max-width 150px
    overflow hidden
    text-overflow ellipsis
</style>
